// The backoffice chrome: one dark rail, three destinations, the signed-in
// admin. Deliberately denser and plainer than the console — this is a tool
// for support, not a product surface.
import { Building2, LogOut, ScrollText, SlidersHorizontal } from "lucide-react";
import { NavLink, Outlet } from "react-router";
import { cn } from "@/lib/utils";
import { useAuth } from "../auth/AuthContext";

const NAV = [
  { to: "/tenants", label: "Tenants", icon: Building2 },
  { to: "/prompts", label: "Prompts", icon: SlidersHorizontal },
  { to: "/runs", label: "Runs", icon: ScrollText },
] as const;

export function Shell() {
  const { admin, signOut } = useAuth();

  return (
    <div className="flex h-screen bg-canvas">
      <aside className="flex w-[220px] shrink-0 flex-col bg-chrome-deep text-white">
        <div className="px-5 pt-6 pb-4">
          <div className="font-display text-[0.95rem] font-bold tracking-[0.08em] uppercase">
            GroundBrain
          </div>
          <div className="font-display text-[0.65rem] tracking-[0.18em] text-white/50 uppercase">
            Backoffice
          </div>
        </div>
        <nav className="flex flex-1 flex-col gap-1 px-3">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 font-display text-[0.78rem] font-semibold tracking-[0.06em] uppercase transition-colors",
                  isActive
                    ? "bg-white/10 text-white"
                    : "text-white/60 hover:bg-white/5 hover:text-white",
                )
              }
            >
              <Icon className="size-4" aria-hidden />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 px-5 py-4">
          <div className="truncate text-[0.78rem] text-white/80">{admin?.email}</div>
          <button
            type="button"
            onClick={signOut}
            className="mt-2 flex items-center gap-2 text-[0.72rem] text-white/50 hover:text-white"
          >
            <LogOut className="size-3.5" aria-hidden />
            Sign out
          </button>
        </div>
      </aside>
      <main className="min-w-0 flex-1 overflow-y-auto">
        <div className="mx-auto max-w-[1200px] px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
